import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  Button,
  FormControl,
  InputLabel,
  TextField,
  Switch,
  FormControlLabel
} from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { useFormik } from 'formik'
import { currencyFormValidation } from '../../../../../utils/validationSchema'
import { FormLoader } from '../../../../Loader/FormLoader'
import { useStyles } from './Styles'
import { NamedRoutes } from '../../../../../routes'

const CurrencyForm = ({ currencyData, onSubmit }) => {
  const classes = useStyles()
  const intl = useIntl()
  const history = useHistory()

  const CurrencyForm = useFormik({
    initialValues: {
      name: currencyData?.name || '',
      key: currencyData?.key || '',
      code: currencyData?.code || null,
      enable_core: currencyData?.enable_core || false,
      core_sender_id: currencyData?.core_sender_id || '',
      core_sender_default_name: currencyData?.core_sender_default_name || '',
      core_sender_password: currencyData?.core_sender_password || '',
      core_service_code: currencyData?.core_service_code || '',
      core_settlement_amount_code: currencyData?.core_settlement_amount_code || '',
      enable_none_core: currencyData?.enable_none_core || false,
      none_core_sender_id: currencyData?.none_core_sender_id || '',
      none_core_sender_default_name: currencyData?.none_core_sender_default_name || '',
      none_core_sender_password: currencyData?.none_core_sender_password || '',
      none_core_service_code: currencyData?.none_core_service_code || '',
      none_core_settlement_amount_code: currencyData?.none_core_settlement_amount_code || ''
    },
    validateOnMount: true,
    validateOnBlur: true,
    validateOnChange: true,
    validationSchema: currencyFormValidation,
    onSubmit: ((values, actions) => {
      onSubmit(values, actions)
    })
  })

  return (
    <form onSubmit={CurrencyForm.handleSubmit} noValidate autoComplete="off" className={classes.formWrapper}>

      {/* Name Field */}
      <div className={classes.BasicInfoRow}>
        <InputLabel id="Currency.Name">
          <FormattedMessage id='Currencies.Form.Field.Name' />
        </InputLabel>
        <FormControl variant="outlined">
          <TextField
            placeholder={intl.formatMessage({ id: 'Currencies.Form.Field.Name.Placeholder' })}
            id="Currency.Name"
            type="text"
            margin="dense"
            variant="outlined"
            name="name"
            value={CurrencyForm.values.name}
            onChange={CurrencyForm.handleChange}
            onBlur={CurrencyForm.handleBlur}
            helperText={CurrencyForm.errors.name && CurrencyForm.touched.name && CurrencyForm.errors.name}
            error={CurrencyForm.errors.name && CurrencyForm.touched.name !== undefined}
          />
        </FormControl>
      </div>

      {/* Key Field */}
      <div className={classes.BasicInfoRow}>
        <InputLabel id="Currency.Key">
          <FormattedMessage id='Currencies.Form.Field.Key' />
        </InputLabel>
        <FormControl variant="outlined">
          <TextField
            placeholder={intl.formatMessage({ id: 'Currencies.Form.Field.Key.Placeholder' })}
            id="Currency.Key"
            type="text"
            margin="dense"
            variant="outlined"
            name="key"
            value={CurrencyForm.values.key}
            onChange={CurrencyForm.handleChange}
            onBlur={CurrencyForm.handleBlur}
            helperText={CurrencyForm.errors.key && CurrencyForm.touched.key && CurrencyForm.errors.key}
            error={CurrencyForm.errors.key && CurrencyForm.touched.key !== undefined}
          />
        </FormControl>
      </div>

      {/* Code Field */}
      <div className={classes.BasicInfoRow}>
        <InputLabel id="Currency.Code">
          <FormattedMessage id='Currencies.Form.Field.Code' />
        </InputLabel>
        <FormControl variant="outlined">
          <TextField
            placeholder={intl.formatMessage({ id: 'Currencies.Form.Field.Code.Placeholder' })}
            id="Currency.Code"
            type="number"
            margin="dense"
            variant="outlined"
            name="code"
            value={CurrencyForm.values.code}
            onChange={CurrencyForm.handleChange}
            onBlur={CurrencyForm.handleBlur}
            helperText={CurrencyForm.errors.code && CurrencyForm.touched.code && CurrencyForm.errors.code}
            error={CurrencyForm.errors.code && CurrencyForm.touched.code !== undefined}
          />
        </FormControl>
      </div>

      {/* Enable Core Switch */}
      <div className={classes.BasicInfoRow}>
        <InputLabel id="Currency.EnableCore">
          <FormattedMessage id='Currencies.Form.Field.EnableCore' />
        </InputLabel>
        <FormControl variant="outlined">
          <FormControlLabel
            control={
              <Switch
                checked={CurrencyForm.values.enable_core}
                onChange={CurrencyForm.handleChange}
                name="enable_core"
                color="primary"
              />
            }
            label={intl.formatMessage({ id: CurrencyForm.values.enable_core ? 'Common.Yes' : 'Common.No' })}
            className={classes.switchControl}
          />
        </FormControl>
      </div>
      <div className={classes.BasicInfoRow}>
        <InputLabel id="Currency.CoreSenderId">
          <FormattedMessage id='Currencies.Form.Field.CoreSenderId' />
        </InputLabel>
        <FormControl variant="outlined">
          <TextField
            placeholder={intl.formatMessage({ id: 'Currencies.Form.Field.CoreSenderId.Placeholder' })}
            id="Currency.CoreSenderId"
            type="text"
            margin="dense"
            variant="outlined"
            name="core_sender_id"
            value={CurrencyForm.values.core_sender_id}
            onChange={CurrencyForm.handleChange}
            onBlur={CurrencyForm.handleBlur}
            helperText={CurrencyForm.errors.core_sender_id && CurrencyForm.touched.core_sender_id && CurrencyForm.errors.core_sender_id}
            error={CurrencyForm.errors.core_sender_id && CurrencyForm.touched.core_sender_id !== undefined}
          />
        </FormControl>
      </div>

      <div className={classes.BasicInfoRow}>
        <InputLabel id="Currency.CoreSenderDefaultName">
          <FormattedMessage id='Currencies.Form.Field.CoreSenderDefaultName' />
        </InputLabel>
        <FormControl variant="outlined">
          <TextField
            placeholder={intl.formatMessage({ id: 'Currencies.Form.Field.CoreSenderDefaultName.Placeholder' })}
            id="Currency.CoreSenderDefaultName"
            type="text"
            margin="dense"
            variant="outlined"
            name="core_sender_default_name"
            value={CurrencyForm.values.core_sender_default_name}
            onChange={CurrencyForm.handleChange}
            onBlur={CurrencyForm.handleBlur}
            helperText={CurrencyForm.errors.core_sender_default_name && CurrencyForm.touched.core_sender_default_name && CurrencyForm.errors.core_sender_default_name}
            error={CurrencyForm.errors.core_sender_default_name && CurrencyForm.touched.core_sender_default_name !== undefined}
          />
        </FormControl>
      </div>

      <div className={classes.BasicInfoRow}>
        <InputLabel id="Currency.CoreSenderPassword">
          <FormattedMessage id='Currencies.Form.Field.CoreSenderPassword' />
        </InputLabel>
        <FormControl variant="outlined">
          <TextField
            placeholder={intl.formatMessage({ id: 'Currencies.Form.Field.CoreSenderPassword.Placeholder' })}
            id="Currency.CoreSenderPassword"
            type="text"
            margin="dense"
            variant="outlined"
            name="core_sender_password"
            value={CurrencyForm.values.core_sender_password}
            onChange={CurrencyForm.handleChange}
            onBlur={CurrencyForm.handleBlur}
            helperText={CurrencyForm.errors.core_sender_password && CurrencyForm.touched.core_sender_password && CurrencyForm.errors.core_sender_password}
            error={CurrencyForm.errors.core_sender_password && CurrencyForm.touched.core_sender_password !== undefined}
          />
        </FormControl>
      </div>

      <div className={classes.BasicInfoRow}>
        <InputLabel id="Currency.CoreServiceCode">
          <FormattedMessage id='Currencies.Form.Field.CoreServiceCode' />
        </InputLabel>
        <FormControl variant="outlined">
          <TextField
            placeholder={intl.formatMessage({ id: 'Currencies.Form.Field.CoreServiceCode.Placeholder' })}
            id="Currency.CoreServiceCode"
            type="text"
            margin="dense"
            variant="outlined"
            name="core_service_code"
            value={CurrencyForm.values.core_service_code}
            onChange={CurrencyForm.handleChange}
            onBlur={CurrencyForm.handleBlur}
            helperText={CurrencyForm.errors.core_service_code && CurrencyForm.touched.core_service_code && CurrencyForm.errors.core_service_code}
            error={CurrencyForm.errors.core_service_code && CurrencyForm.touched.core_service_code !== undefined}
          />
        </FormControl>
      </div>

      <div className={classes.BasicInfoRow}>
        <InputLabel id="Currency.CoreSettlementAmountCode">
          <FormattedMessage id='Currencies.Form.Field.CoreSettlementAmountCode' />
        </InputLabel>
        <FormControl variant="outlined">
          <TextField
            placeholder={intl.formatMessage({ id: 'Currencies.Form.Field.CoreSettlementAmountCode.Placeholder' })}
            id="Currency.CoreSettlementAmountCode"
            type="text"
            margin="dense"
            variant="outlined"
            name="core_settlement_amount_code"
            value={CurrencyForm.values.core_settlement_amount_code}
            onChange={CurrencyForm.handleChange}
            onBlur={CurrencyForm.handleBlur}
            helperText={CurrencyForm.errors.core_settlement_amount_code && CurrencyForm.touched.core_settlement_amount_code && CurrencyForm.errors.core_settlement_amount_code}
            error={CurrencyForm.errors.core_settlement_amount_code && CurrencyForm.touched.core_settlement_amount_code !== undefined}
          />
        </FormControl>
      </div>

      {/* Enable None Core Switch */}
      <div className={classes.BasicInfoRow}>
        <InputLabel id="Currency.EnableNoneCore">
          <FormattedMessage id='Currencies.Form.Field.EnableNoneCore' />
        </InputLabel>
        <FormControl variant="outlined">
          <FormControlLabel
            control={
              <Switch
                checked={CurrencyForm.values.enable_none_core}
                onChange={CurrencyForm.handleChange}
                name="enable_none_core"
                color="primary"
              />
            }
            label={intl.formatMessage({ id: CurrencyForm.values.enable_none_core ? 'Common.Yes' : 'Common.No' })}
            className={classes.switchControl}
          />
        </FormControl>
      </div>
      <div className={classes.BasicInfoRow}>
        <InputLabel id="Currency.NoneCoreSenderId">
          <FormattedMessage id='Currencies.Form.Field.NoneCoreSenderId' />
        </InputLabel>
        <FormControl variant="outlined">
          <TextField
            placeholder={intl.formatMessage({ id: 'Currencies.Form.Field.NoneCoreSenderId.Placeholder' })}
            id="Currency.NoneCoreSenderId"
            type="text"
            margin="dense"
            variant="outlined"
            name="none_core_sender_id"
            value={CurrencyForm.values.none_core_sender_id}
            onChange={CurrencyForm.handleChange}
            onBlur={CurrencyForm.handleBlur}
            helperText={CurrencyForm.errors.none_core_sender_id && CurrencyForm.touched.none_core_sender_id && CurrencyForm.errors.none_core_sender_id}
            error={CurrencyForm.errors.none_core_sender_id && CurrencyForm.touched.none_core_sender_id !== undefined}
          />
        </FormControl>
      </div>

      <div className={classes.BasicInfoRow}>
        <InputLabel id="Currency.NoneCoreSenderDefaultName">
          <FormattedMessage id='Currencies.Form.Field.NoneCoreSenderDefaultName' />
        </InputLabel>
        <FormControl variant="outlined">
          <TextField
            placeholder={intl.formatMessage({ id: 'Currencies.Form.Field.NoneCoreSenderDefaultName.Placeholder' })}
            id="Currency.NoneCoreSenderDefaultName"
            type="text"
            margin="dense"
            variant="outlined"
            name="none_core_sender_default_name"
            value={CurrencyForm.values.none_core_sender_default_name}
            onChange={CurrencyForm.handleChange}
            onBlur={CurrencyForm.handleBlur}
            helperText={CurrencyForm.errors.none_core_sender_default_name && CurrencyForm.touched.none_core_sender_default_name && CurrencyForm.errors.none_core_sender_default_name}
            error={CurrencyForm.errors.none_core_sender_default_name && CurrencyForm.touched.none_core_sender_default_name !== undefined}
          />
        </FormControl>
      </div>

      <div className={classes.BasicInfoRow}>
        <InputLabel id="Currency.NoneCoreSenderPassword">
          <FormattedMessage id='Currencies.Form.Field.NoneCoreSenderPassword' />
        </InputLabel>
        <FormControl variant="outlined">
          <TextField
            placeholder={intl.formatMessage({ id: 'Currencies.Form.Field.NoneCoreSenderPassword.Placeholder' })}
            id="Currency.NoneCoreSenderPassword"
            type="text"
            margin="dense"
            variant="outlined"
            name="none_core_sender_password"
            value={CurrencyForm.values.none_core_sender_password}
            onChange={CurrencyForm.handleChange}
            onBlur={CurrencyForm.handleBlur}
            helperText={CurrencyForm.errors.none_core_sender_password && CurrencyForm.touched.none_core_sender_password && CurrencyForm.errors.none_core_sender_password}
            error={CurrencyForm.errors.none_core_sender_password && CurrencyForm.touched.none_core_sender_password !== undefined}
          />
        </FormControl>
      </div>

      <div className={classes.BasicInfoRow}>
        <InputLabel id="Currency.NoneCoreServiceCode">
          <FormattedMessage id='Currencies.Form.Field.NoneCoreServiceCode' />
        </InputLabel>
        <FormControl variant="outlined">
          <TextField
            placeholder={intl.formatMessage({ id: 'Currencies.Form.Field.NoneCoreServiceCode.Placeholder' })}
            id="Currency.NoneCoreServiceCode"
            type="text"
            margin="dense"
            variant="outlined"
            name="none_core_service_code"
            value={CurrencyForm.values.none_core_service_code}
            onChange={CurrencyForm.handleChange}
            onBlur={CurrencyForm.handleBlur}
            helperText={CurrencyForm.errors.none_core_service_code && CurrencyForm.touched.none_core_service_code && CurrencyForm.errors.none_core_service_code}
            error={CurrencyForm.errors.none_core_service_code && CurrencyForm.touched.none_core_service_code !== undefined}
          />
        </FormControl>
      </div>

      <div className={classes.BasicInfoRow}>
        <InputLabel id="Currency.NoneCoreSettlementAmountCode">
          <FormattedMessage id='Currencies.Form.Field.NoneCoreSettlementAmountCode' />
        </InputLabel>
        <FormControl variant="outlined">
          <TextField
            placeholder={intl.formatMessage({ id: 'Currencies.Form.Field.NoneCoreSettlementAmountCode.Placeholder' })}
            id="Currency.NoneCoreSettlementAmountCode"
            type="text"
            margin="dense"
            variant="outlined"
            name="none_core_settlement_amount_code"
            value={CurrencyForm.values.none_core_settlement_amount_code}
            onChange={CurrencyForm.handleChange}
            onBlur={CurrencyForm.handleBlur}
            helperText={CurrencyForm.errors.none_core_settlement_amount_code && CurrencyForm.touched.none_core_settlement_amount_code && CurrencyForm.errors.none_core_settlement_amount_code}
            error={CurrencyForm.errors.none_core_settlement_amount_code && CurrencyForm.touched.none_core_settlement_amount_code !== undefined}
          />
        </FormControl>
      </div>


      {/* Submit Buttons */}
      <div className={classes.SubmitRow}>
        <button
          type="submit"
          disabled={CurrencyForm.isSubmitting || !CurrencyForm.isValid}
          className={classes.AddAdminSubmit}
        >
          <FormattedMessage id='AdditionalInfo.button.submit' />
        </button>
        <Button onClick={() => history.push(NamedRoutes.workspace.currencies.list)} color="primary">
          <FormattedMessage id='ChangePhone.DialogActions.cancel' />
        </Button>
      </div>
      {CurrencyForm.isSubmitting && <FormLoader loading={true} />}
    </form>
  )
}

export default CurrencyForm

